// src/stone/icons/DollarInvoicePay2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarInvoicePay2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20 5.667a1 1 0 0 1 1 1v26.666a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M18.21 9.099c2.895-.359 6.227.303 8.088 1.28a1 1 0 0 1-.93 1.771c-1.472-.773-4.39-1.379-6.911-1.066-1.251.155-2.295.523-3.007 1.104-.672.549-1.117 1.339-1.117 2.55 0 1.056.527 1.758 1.584 2.368 1.062.613 2.49 1.029 4.099 1.497l.264.078c1.64.478 3.456 1.025 4.854 1.946 1.465.966 2.533 2.387 2.533 4.529 0 1.782-.74 3.148-1.923 4.096-1.144.918-2.65 1.407-4.18 1.617-3.04.419-6.594-.205-8.71-1.363a1 1 0 0 1 .96-1.755c1.69.925 4.802 1.505 7.477 1.137 1.327-.183 2.441-.586 3.202-1.196.723-.58 1.174-1.378 1.174-2.536 0-1.327-.6-2.177-1.634-2.859-1.103-.727-2.62-1.202-4.313-1.696l-.345-.1c-1.524-.443-3.176-.923-4.458-1.663-1.443-.833-2.584-2.097-2.584-4.1 0-1.794.702-3.16 1.852-4.1 1.111-.906 2.568-1.358 4.025-1.539" })
    ]
  }
);
var DollarInvoicePay2X_default = DollarInvoicePay2X;

export {
  DollarInvoicePay2X,
  DollarInvoicePay2X_default
};
